import axios from 'axios';
import apiClient, { AUTH_HEALTH_URL } from './api';
import { clearAllActivityListState } from '../utils/activityFiltersStorage';

/**
 * Auth service for handling Google OAuth authentication with Spring Security
 * Uses session cookies - no manual token management needed!
 */
class AuthService {
  /**
   * Initiate Google OAuth login via Spring Security
   * Redirects to backend OAuth2 endpoint
   */
  loginWithGoogle(): void {
    // Goes through Vite proxy → backend OAuth2 endpoint
    window.location.href = '/oauth2/authorization/google';
  }

  /**
   * Check if user is authenticated by calling backend
   * Session cookie is automatically sent
   */
  async isAuthenticated(): Promise<boolean> {
    try {
      await apiClient.get(AUTH_HEALTH_URL);
      return true;
    } catch (error) {
      // Only 401 means "not authenticated"; network/server errors must propagate
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        return false;
      }
      throw error;
    }
  }

  /**
   * Logout - call backend logout endpoint
   */
  async logout(): Promise<void> {
    try {
      // /logout lives outside the API prefix, so override baseURL
      await apiClient.post('/logout', null, { baseURL: '' });
    } finally {
      clearAllActivityListState();
      window.location.href = '/login?logout';
    }
  }
}

export default new AuthService();
